import qs from 'qs';

const Role = {
    namespaced: true,

    state: {
        roleData: [],
    },

    getters: {
        roleData (state) {
            return state.roleData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['roleData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['roleData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['roleData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['roleData'] = state['roleData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по ролям
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getRoleData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'role/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data.map(role => {
                            const permission = [];
                            role.permission.split(',').forEach(perm => {
                               permission.push({
                                   object: perm.split(':')[0],
                                   level: perm.split(':')[1]
                               });
                            });
                            return {
                                roleId: role.roleId,
                                roleKey: role.roleKey,
                                roleTitle: role.roleTitle,
                                roleColor: role.roleColor,
                                permission: permission
                            }
                        })
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по ролям ставок получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN role.js | getRoleData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по ролям ставок!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по ролям
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveRoleData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'role/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по роли успешно отредактированы!');

                    // Если сохранение нового
                    } else {
    //                    data.data.roleId = response.data[0].roleId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая роль успешно создана!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN role.js | saveRoleData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление роли
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeRoleData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'role/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Роль успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении роли!'),
                    console.log('ERROR IN role.js | removeRoleData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Role;





// WEBPACK FOOTER //
// ./src/store/modules/role.js